// extracted by mini-css-extract-plugin
export default {"wrapper":"SensorChartFullScreen_wrapper__eMVb7","indicators":"SensorChartFullScreen_indicators__-AmmW"};